export default __webpack_public_path__ + "481de3b8622cf90d94450f4019359916.svg";